module.exports = __webpack_public_path__ + "img/v4_h8.13715d5b.png";